export const plasmaGun = {
    name: "plasma Gun",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/plasma%20Gun.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/plasma%20Gun.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/plasma%20Gun.png",
    level: "1",
    speed: ["0", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/plasma%20Gun.wav",
    class: "Shoot",
    ammo: "100",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/plasma%20Gun.json",
};

export const rocketLauncher = {
    name: "rocket launcher",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/rocket%20launcher.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/rocket%20launcher.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/rocket%20launcher.png",
    level: "1",
    speed: ["-200", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/rocket%20launcher.wav",
    class: "ShootZig",
    ammo: "50",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/rocket%20launcher.json",
};
export const plasmaBall = {
    name: "Plasma Ball",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Plasma%20Ball.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/Plasma%20Ball.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/Plasma%20Ball.png",
    level: "1",
    speed: ["0", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/Plasma%20Ball.wav",
    class: "ShootPlasma",
    ammo: "10",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/Plasma%20Ball.json",
};

export const blasterGun = {
    name: "blaster gun",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/blaster%20gun.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/blaster%20gun.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/blaster%20gun.png",
    level: "1",
    speed: ["-200", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/blaster%20gun.wav",
    class: "ShootZig",
    ammo: "20",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/blaster%20gun.json",
};

export const machineGun = {
    name: "Machine Gun",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Machine%20Gun.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/Machine%20Gun.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/Machine%20Gun.png",
    level: "1",
    speed: ["-2", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/Machine%20Gun.wav",
    class: "ShootRotate",
    ammo: "15",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/Machine%20Gun%20.json",
};

export const primaryWeapon = {
    name: "Primary weapon",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Primary%20weapon.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/Primary%20weapon.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/Primary%20weapon.png",
    level: "1",
    speed: ["0", "-200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/Primary%20weapon.wav",
    class: "ShootRocket",
    ammo: "5",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/Primary%20weapon.json",
};

export const laser = {
    name: "Laser",
    image: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Laser.gif",

    sprite_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sprite%20photo/Laser.png",
    bar_photo: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/Bar%20photo/Laser.png",
    level: "1",
    speed: ["0", "200"],
    sound: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmbLCWNLsrkiR4FWxg2mMvkTkMm3rbVMJxfLmCmXYqx6di/weapons/sound/Laser.wav",
    class: "Shoot",
    ammo: "80",
    uri: "https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQyYC6NJTmqN3WbuxvHMqLMMEYsuHb6QP58Cfop6QCBwm/weapons/Laser%20.json",
};

export const weapons = {
    plasmaGun,
    rocketLauncher,
    plasmaBall,
    blasterGun,
    machineGun,
    primaryWeapon,
    laser,
};

export const SFM_WEAPON_CONTRACT_ADDRESS =
    "0x19Ff1533aD612770eb0799CD2a4A3CC61f5f41e1";

export const SFM_WEAPON_CONTRACT_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "approved",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_fromTokenId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_toTokenId",
        "type": "uint256"
      }
    ],
    "name": "BatchMetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "MetadataUpdate",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getApproved",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_tokenId",
        "type": "uint256"
      }
    ],
    "name": "getMetadata",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string[]",
            "name": "speed",
            "type": "string[]"
          },
          {
            "internalType": "string",
            "name": "sound",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "class",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "ammo",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonWeapon.Token",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getNftsbyOwner",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "image",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "sprite_photo",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "level",
            "type": "string"
          },
          {
            "internalType": "string[]",
            "name": "speed",
            "type": "string[]"
          },
          {
            "internalType": "string",
            "name": "sound",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "class",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "ammo",
            "type": "string"
          }
        ],
        "internalType": "struct SafemoonWeapon.Token[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "getTokenIdsByOwner",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "uri",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_level",
        "type": "string"
      },
      {
        "internalType": "string[]",
        "name": "_speed",
        "type": "string[]"
      },
      {
        "internalType": "string",
        "name": "_sound",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_class",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_ammo",
        "type": "string"
      }
    ],
    "name": "safeMint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "tokenMetadata",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "image",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "sprite_photo",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "level",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "sound",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "class",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "ammo",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];
